<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="invselect" :options="item.options" :minrigth="item.minrigth"
						:maxrigth="item.maxrigth" :minleft="item.minleft" :maxleft="item.maxleft"
						:lablewith="item.lablewith" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup ref="btngroup" :chackbox="false" :show="showorhide"
						@showclick="showclick" @hide="hide" @select="select" @reset="reset"></CommonBtngroup>
				</div>
			</div>
			<div class="TableBox"
				style="box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Invoicelisttable @onRowClick="onRowClick" @SaleBillExport="SaleBillExport" :tableData="tableData"
					:total="total" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Invoicelisttable>
			</div>
			<div class="TableBox"
				style="margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;display: initial;">
				<Invoicelistbottom :tableDataDetail="tableDataDetail" :tableDataUnique="tableDataUnique" :sbmid="sbmid">
				</Invoicelistbottom>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Invoicelisttable from './components/invoicelisttable.vue'
	import Invoicelistbottom from './components/invoicelist-bottom.vue'
	import utils from '../../../common/utils'
	import {
		SaleBillList,
		SaleBillExport,
		InventoryClassList,
		CusType,
		HelperDPhVoucherType,
		Status,
		SaleBillDetail,
		SaleBillDetailUnique,
		HelperInvoiceChecked,
		InvoiceValidStatus
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Invoicelisttable,
			Invoicelistbottom
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				dialogVisibles: false,
				showorhide: true,
				sbmid: "",
				tableDataDetail: [],
				tableDataUnique: [],
				formdata: [{
						inputdata: '',
						title: '发票号码',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '发票检验状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'selectMultiple',
						width: '210px',
						lablewith: '95px',
						options: [{
								value: '发票照片已上传未通过',
								key: '1'
							}, {
								value: '发票照片已上传已验证',
								key: '2'
							}, {
								value: '发票照片已二次确认',
								key: '3'
							},
							{
								value: '未上传发票照片',
								key: '4'
							},
						]
					},
					{
						inputdata: '',
						title: "开票日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						//   lablewith: '95px'
					},
					{
						inputdata: '',
						title: '创建公司',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '92px'
					},
					{
						inputdata: '',
						title: '开票金额',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: '',
						inputtype: 'numbers',
						width: '74px',
						lablewith: '95px',
						minleft: 0,
						maxleft: undefined,
						minrigth: 0,
						maxrigth: undefined
					},

					{
						inputdata: '',
						title: '付款方名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '135px'
					},
					{
						inputdata: '',
						title: "入库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						//   lablewith: '95px'
					},
					{
						inputdata: '',
						title: '产品型号/名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},

					{
						inputdata: '',
						title: '出库单号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '发票方向',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '95px',
						options: [{
							value: '蓝票',
							key: '0'
						}, {
							value: '红票',
							key: '1'
						}, ]
					},
					{
						inputdata: '',
						title: "审核日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						//   lablewith: '95px'
					},
					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '95px',
						options: [

						]
					},
					{
						inputdata: '',
						title: '终端医院',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '发票有效性状态',
						fontSize: '14px',
						color: 'red',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '110px',
						options: []
					}
				],
				fromdatalist: [],
				from: {
					invoiceNo: '',
					invoiceChecked: '',
					sbDate1: '',
					sbDate2: '',
					salerName: '',
					total1: '',
					total2: '',
					createTime1: '',
					createTime2: '',
					buyerName: '',
					inventory: '',
					verifyTime1: '',
					verifyTime2: '',
					vouCode: '',
					returnFlag: '',
					invClass: '',
					TerminalHPName: '',
					IsValid: ''
				}
			}
		},
		mounted() {
			this.$message.warning("请填写搜索条件！");
			this.$refs.invselect[2].startTime = this.$utils.getFYearDate();
			this.getInvoiceValidStatus()
			this.inventoryClassList()
			this.helperInvoiceChecked()
			// this.saleBillList()
		},
		methods: {
			async getInvoiceValidStatus() {
				let { code, data } = await InvoiceValidStatus({})
				if (code == 0) {
					this.formdata[13].options = []
					data.map((item) => {
						this.formdata[13].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				}
			},
			// 列表
			async saleBillList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await SaleBillList({
					invoiceNo: this.from.invoiceNo,
					invoiceChecked: this.from.invoiceChecked,
					sbDate1: this.from.sbDate1,
					sbDate2: this.from.sbDate2,
					salerName: this.from.salerName,
					total1: this.from.total1,
					total2: this.from.total2,
					createTime1: this.from.createTime1,
					createTime2: this.from.createTime2,
					buyerName: this.from.buyerName,
					inventory: this.from.inventory,
					verifyTime1: this.from.verifyTime1,
					verifyTime2: this.from.verifyTime2,
					vouCode: this.from.vouCode,
					returnFlag: this.from.returnFlag,
					invClass: this.from.invClass,
					TerminalHPName: this.from.TerminalHPName,
					IsValid: this.from.IsValid,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				// //console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data
				} else {
					this.$message({
						type: 'warning',
						message: message
					})
				}
				loading.close();
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdata[11].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[11].options.push(obj)
					})
				}
			},
			// 导出
			async SaleBillExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出请稍后...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await SaleBillExport({
					invoiceNo: this.from.invoiceNo,
					invoiceChecked: this.from.invoiceChecked,
					sbDate1: this.from.sbDate1,
					sbDate2: this.from.sbDate2,
					salerName: this.from.salerName,
					total1: this.from.total1,
					total2: this.from.total2,
					createTime1: this.from.createTime1,
					createTime2: this.from.createTime2,
					buyerName: this.from.buyerName,
					inventory: this.from.inventory,
					verifyTime1: this.from.verifyTime1,
					verifyTime2: this.from.verifyTime2,
					vouCode: this.from.vouCode,
					returnFlag: this.from.returnFlag,
					invClass: this.from.invClass,
					TerminalHPName: this.from.TerminalHPName,
					IsValid: this.from.IsValid,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				let date = new Date()
				let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
				if (resexprot) {
					utils.downloadFile(resexprot.data, `发票管理${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
				loading.close();
			},
			async helperInvoiceChecked() {
				let {
					code,
					data
				} = await HelperInvoiceChecked({})
				if (code == 0) {
					this.formdata[1].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[1].options.push(obj)
					})
				}
			},
			reset() {
				for (let index in this.$refs.invselect) {
					if (index == 2 || index == 6 || index == 10) {
						this.$refs.invselect[index].startTime = ''
						this.$refs.invselect[index].endTime = ''
					} else if (index == 4) {
						this.$refs.invselect[index].modelvalueleft = undefined
						this.$refs.invselect[index].modelvalueright = undefined
					} else {
						this.$refs.invselect[index].modelvalue = ''
					}
				}
				this.$refs.btngroup.checkeds = false
			},
			cancel() {
				//console.log('name')
				this.dialogVisibles = false
			},
			dialogOK() {
				//console.log('name2')
				this.dialogVisibles = false
			},
			select() {
				for (let item of this.formdata) {
					this.fromdatalist.push(item.inputdata)
				}
				this.pageindex = 1
				try {
					this.from.invoiceNo = this.$refs.invselect[0].modelvalue
					this.from.invoiceChecked = this.$refs.invselect[1].modelvalue.join(',')
					this.from.sbDate1 = this.$refs.invselect[2].startTime
					this.from.sbDate2 = this.$refs.invselect[2].endTime
					this.from.salerName = this.$refs.invselect[3].modelvalue
					this.from.total1 = this.$refs.invselect[4].modelvalueleft
					this.from.total2 = this.$refs.invselect[4].modelvalueright
					this.from.createTime1 = this.$refs.invselect[6].startTime
					this.from.createTime2 = this.$refs.invselect[6].endTime
					this.from.buyerName = this.$refs.invselect[5].modelvalue
					this.from.inventory = this.$refs.invselect[7].modelvalue
					this.from.verifyTime1 = this.$refs.invselect[10].startTime
					this.from.verifyTime2 = this.$refs.invselect[10].endTime
					this.from.vouCode = this.$refs.invselect[8].modelvalue
					this.from.returnFlag = this.$refs.invselect[9].modelvalue
					this.from.invClass = this.$refs.invselect[11].modelvalue
					this.from.TerminalHPName = this.$refs.invselect[12].modelvalue
					this.from.IsValid = this.$refs.invselect[13].modelvalue
					this.saleBillList()
				} catch (error) {
					this.saleBillList()
				}
			},
			// 明细
			async SaleBillDetail() {
				let {
					data,
					code
				} = await SaleBillDetail({
					sbmid: this.sbmid
				})
				if (code == 0) {
					this.tableDataDetail = data
					this.tableDataMD = data
				}
			},
			// 唯一码
			async SaleBillDetailUnique() {
				let {
					data,
					code,
					message
				} = await SaleBillDetailUnique({
					sbmid: this.sbmid
				})
				if (code == 0) {
					this.tableDataUnique = data
					this.tableDataMD = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			onRowClick(val) {
				//console.log(val, 'val');
				this.sbmid = val.SBMID
				this.SaleBillDetail()
				this.SaleBillDetailUnique()
			},
			DespatchExport() {

			},
			hide() {
				this.showorhide = false
			},
			showclick() {
				this.showorhide = true
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.saleBillList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.saleBillList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 145px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 300px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 145px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>